import { CSSProperties } from 'react'

const imageWidth = 188
const commonRow = {
  display: 'flex',
  alignItems: 'center',
} as CSSProperties

export const s = {
  root: {
    height: 191,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#FFFFFF',
  } as CSSProperties,
  image: {
    height: 191,
    width: imageWidth,
    objectFit: 'cover',
  } as CSSProperties,
  column: {
    width: `calc(100% - ${imageWidth}px)`,
    padding: '25px 31px 25px 24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  } as CSSProperties,
  row: commonRow,
  spaceBetweenRow: {
    ...commonRow,
    justifyContent: 'space-between',
  } as CSSProperties,
  venueSpaceRow: {
    ...commonRow,
    marginBottom: 4,
  },
  spaceName: {
    marginLeft: 10,
  },
  normalText: {
    marginLeft: 8,
  },
  capacity: {
    marginLeft: 24,
  },
  buttonsGroup: {
    display: 'flex',
    gap: 16,
  } as CSSProperties,
  ghostButton: {
    padding: 0,
  },
  primaryButton: {
    padding: '5px 10px',
  },
}
